import { carpayPaymentEmailRoute } from '@views/Carpay/PaymentEmail/route.const'
import { carpayPaymentInputRoute } from '@views/Carpay/PaymentInput/route.const'
import { carpayPaymentMethodRoute } from '@views/Carpay/PaymentMethod/route.const'

const PAYMENT_FLOW_PATHS = [
    carpayPaymentEmailRoute().split('/').pop(),
    carpayPaymentInputRoute().split('/').pop(),
    carpayPaymentMethodRoute().split('/').pop()
]

export const isInsidePaymentFlow = (currentPath: string) => {
    return PAYMENT_FLOW_PATHS.some((path) => currentPath === path)
}
